import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiDelete, apiGet, apiPatch, apiPost } from '../client';
import { qk } from './keys';
import type { FamilyMember, FamilyMemberInput } from '../types';

export function useFamily() {
  return useQuery({
    queryKey: qk.family,
    queryFn: () => apiGet<FamilyMember[]>('/me/family-members'),
  });
}

export function useAddFamilyMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: FamilyMemberInput) =>
      apiPost<FamilyMember>('/me/family-members', body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.family });
    },
  });
}

export function useUpdateFamilyMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Partial<FamilyMemberInput> }) =>
      apiPatch<FamilyMember>(`/me/family-members/${id}`, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.family });
    },
  });
}

export function useDeleteFamilyMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiDelete<void>(`/me/family-members/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.family });
    },
  });
}
